import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./InfoComponent.module.css";
import { useTranslation } from "@i18n";
import { useState } from "react";
import { useEffect } from "react";
import { api__getFinanceUploadDocuments } from "@/apis/freeFinance/getFinanceUploadDocuments";
import UploadOfferAttachments from "@/pages/tracking/components/SharedComponents/StepDetailsComponent_TS/StepBody/UploadOfferAttachments/UploadOfferAttachments";
import { deleteDocuments as _deleteDocuments, deleteFileObject as _deleteFileObject, handleFileChange } from "@/pages/tracking/utls";
import Loader3d from "./Loader3d";
import useHelpers from "@hooks/useHelpers";
import useButtonLoading from "@hooks/useButtonLoading";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
var UserUploadInfo = function UserUploadInfo(_ref) {
  var queryParams = _ref.queryParams,
    updateLoader = _ref.updateLoader,
    postData = _ref.postData,
    mobileNUmberForEvent = _ref.mobileNUmberForEvent,
    InformParentPopUpIsOpen = _ref.InformParentPopUpIsOpen;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var buttonLoading = useButtonLoading();
  var _useState = useState({
      order_uuid: queryParams.get("uuid"),
      orderId: queryParams.get("orderid"),
      filesLaterNames: [],
      g4_data: {}
    }),
    data = _useState[0],
    setData = _useState[1];
  var _useState2 = useState([]),
    filesDataCanSubmit = _useState2[0],
    setFilesDataCanSubmit = _useState2[1];
  var _useState3 = useState(null),
    error = _useState3[0],
    setError = _useState3[1];

  //-------------------------------------------------------------------
  var _useState4 = useState({}),
    fileObjects = _useState4[0],
    setFileObjects = _useState4[1];
  var _useState5 = useState({}),
    preSignData = _useState5[0],
    setPreSignData = _useState5[1];
  var _useState6 = useState({}),
    detailsDummy = _useState6[0],
    setDetailsDummy = _useState6[1];
  var _useState7 = useState([]),
    uploadDocumentsData = _useState7[0],
    setUploadDocumentsData = _useState7[1];
  //-------------------------------------------------------------------

  useEffect(function () {
    api__getFinanceUploadDocuments(data.order_uuid).then(function (res) {
      setFilesDataCanSubmit(res === null || res === void 0 ? void 0 : res.filesDataCanSubmit);
      updateData("filesLaterNames", res === null || res === void 0 ? void 0 : res.filesLaterNames);
      updateData("g4_data", _objectSpread(_objectSpread({}, (res === null || res === void 0 ? void 0 : res.g4_data) || {}), {}, {
        status: "false",
        platform: getPlatformInfo(),
        order_type: "Finance"
      }));
    })["catch"](function (error) {
      if (error.name === 'ValidationException') {
        navigateTo("/finance/rejected?haveanotherOrder=9&post_id=".concat((postData === null || postData === void 0 ? void 0 : postData.post_id) || ""));
      } else {
        setError(error.message);
      }
    });
  }, []);
  useEffect(function () {
    setDetailsDummy({
      step_body: {
        fields: {
          values: filesDataCanSubmit
        }
      }
    });
  }, [data]);
  var updateData = function updateData(key, value) {
    setData(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
    });
  };
  if (error) {
    return /*#__PURE__*/React.createElement("div", null, "Error:", error);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: stl.InfoComponentContainer
  }, /*#__PURE__*/React.createElement("strong", null, t("validation_attach_required_documents_application_approved", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("p", null, t("validation_attach_required_documents_approve_application", {
    ns: "web_checkout_finance"
  })), (filesDataCanSubmit === null || filesDataCanSubmit === void 0 ? void 0 : filesDataCanSubmit.length) === 0 && /*#__PURE__*/React.createElement("div", {
    className: stl.filerUploadLoading
  }, /*#__PURE__*/React.createElement(Loader3d, null)), (filesDataCanSubmit === null || filesDataCanSubmit === void 0 ? void 0 : filesDataCanSubmit.length) > 0 && /*#__PURE__*/React.createElement(UploadOfferAttachments, {
    InformParentPopUpIsOpen: InformParentPopUpIsOpen,
    details: detailsDummy,
    onFileChange: function onFileChange(file, field) {
      return handleFileChange(file, field, setFileObjects, setPreSignData, setUploadDocumentsData);
    },
    preSignData: preSignData,
    fileObjects: fileObjects,
    uploadDocumentsData: uploadDocumentsData,
    orderId: data.orderId,
    buttonLoading: buttonLoading,
    deleteFileObject: function deleteFileObject(field) {
      return _deleteFileObject(field, setFileObjects);
    },
    setFileObjects: setFileObjects,
    deleteDocuments: function deleteDocuments(field) {
      return _deleteDocuments(field, setUploadDocumentsData);
    },
    stepNum: 2,
    isFinance: true,
    g4_data: data.g4_data,
    dontCheckFiles: true,
    hideTitle: true,
    hasUpcomingFiles: true,
    upcomingFiles: data.filesLaterNames,
    freeFinanceFunctionality: true,
    order_uuid: data.order_uuid,
    updateLoader: updateLoader,
    postData: postData,
    mobileNUmberForEvent: mobileNUmberForEvent,
    sendFormSubmitEvent: true
  }));
};
export default UserUploadInfo;